var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleSignin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2088 4.09175C10.9852 4.09175 11.9586 3.5507 12.5382 2.82928C13.0631 2.17551 13.4459 1.26247 13.4459 0.349433C13.4459 0.22544 13.4349 0.101448 13.413 0C12.5491 0.0338162 11.5102 0.597418 10.8868 1.35265C10.3947 1.92752 9.94633 2.82929 9.94633 3.75359C9.94633 3.88886 9.9682 4.02412 9.97914 4.06921C10.0338 4.08048 10.1213 4.09175 10.2088 4.09175ZM7.47479 17.7309C8.53558 17.7309 9.00583 16.9983 10.3291 16.9983C11.6742 16.9983 11.9695 17.7084 13.1506 17.7084C14.3098 17.7084 15.0863 16.6037 15.819 15.5216C16.6392 14.2817 16.9782 13.0643 17.0001 13.0079C16.9235 12.9854 14.7035 12.0498 14.7035 9.42343C14.7035 7.14648 16.4533 6.12072 16.5517 6.04182C15.3925 4.32847 13.6318 4.28338 13.1506 4.28338C11.8492 4.28338 10.7884 5.09497 10.1213 5.09497C9.39953 5.09497 8.44809 4.32847 7.32168 4.32847C5.17822 4.32847 3.00195 6.15454 3.00195 9.60379C3.00195 11.7455 3.81122 14.0112 4.8064 15.4765C5.65941 16.7164 6.40306 17.7309 7.47479 17.7309Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleSignin);
export default __webpack_public_path__ + "static/media/apple_signin.91bd522bff5873dd071b827aaa9a1a2a.svg";
export { ForwardRef as ReactComponent };